import { OpointAuthProvider } from '@opoint/authjs-react';
import ProjectsOverview from '@/pages/ProjectsOverview';
import './App.css';

function App() {
  return (
    <OpointAuthProvider
      host={import.meta.env.VITE_AUTH_URL}
      callback={import.meta.env.VITE_APP_URL}
    >
      <ProjectsOverview />
    </OpointAuthProvider>
  );
}

export default App;